import { useEffect, useMemo, useRef, useState } from 'react'

const CANVAS_SIZE = 500
const MIN_SIZE = 24
const MAX_SIZE = 1400
const MIN_OPACITY = 0.1
const MAX_OPACITY = 1
const MIN_ZOOM = 0.5
const MAX_ZOOM = 2
const BACKGROUND_LAYER = 'background'
const AURA_LAYER = 'aura'
const ALPHA_THRESHOLD = 8
const SHIRT_LOGO_LEFT_RATIO = 0.32
const SHIRT_LOGO_TOP_RATIO = 0.48
const SHIRT_LOGO_WIDTH_RATIO = 0.36
const SHIRT_LOGO_HEIGHT_RATIO = 0.3

const SHIRT_MASK_URL =
    'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/2a70b88bf_UntitledProject93.png'

const SHIRT_LOGOS = [
    { id: 'none', name: 'None', url: null },
    { id: 'fortnite', name: 'Fortnite', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/6c9826442_UntitledProject-2025-11-18T185412211.png' },
    { id: 'halo2', name: 'Halo 2', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/6a4935ecb_halo2.png' },
    { id: 'nile', name: 'Nile Special', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/9e0fc9415_UntitledProject-2025-11-18T190800320.png' },
    { id: 'uwo', name: 'UWO', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/593ff16cb_UntitledProject-2025-11-18T202837997.png' },
    { id: 'pumpfun', name: 'pump.fun', url: 'https://pump.fun/logo.png' },
]

const BASE_OPTIONS = [
    { id: 'base1', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/aa0ac126e_UntitledProject74.png', name: 'Classic Red' },
    { id: 'base2', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/a9317e893_purpleknuckles.png', name: 'Purple' },
    { id: 'base3', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/ca1975123_yellowkncuckles.png', name: 'Yellow' },
    { id: 'base4', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/b8ff85a34_blueknuckels3.png', name: 'Blue' },
    { id: 'base5', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/a03e636c4_UntitledProject78.png', name: 'Silver' },
]

const HEAD_ASSETS = [
    { id: 'head1', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/d38f3e120_sunglasses.png', name: 'MOG Glasses' },
    { id: 'head2', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/df4c2f548_lasereyes.png', name: 'Laser Eyes' },
    { id: 'head3', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/4bd051c58_hatassetwif.png', name: 'Wif Hat' },
    { id: 'head4', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/4a3d4ac53_Partyhatasset.png', name: 'Party Hat', width: 167, height: 167 },
    { id: 'head5', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/90ae8f7e4_retardioface.png', name: 'Clown Face' },
    { id: 'head6', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/57552aab7_ChatGPTImageNov15202507_18_00PM.png', name: 'Halo', width: 100, height: 100 },
    { id: 'head7', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/7f23c6367_UntitledProject73.png', name: 'Uganda Bandana' },
    { id: 'head8', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/1a67582aa_sunglasses1.png', name: 'Round Glasses' },
    { id: 'head9', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/d81ac37f0_UntitledProject83.png', name: 'Uganda Headwear' },
    { id: 'head10', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/0ff0c2d1b_Hat.png', name: 'Hat', width: 625, height: 625 },
    { id: 'head11', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/afb2fb498_miladyeyes.png', name: 'Milady Eyes' },
    { id: 'head12', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/d3f8f8813_UntitledProject84.png', name: 'Cheech' },
    { id: 'head13', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/06d659418_UntitledProject90.png', name: 'Fish' },
    { id: 'head14', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/9a9b0ea20_UntitledProject96.png', name: 'Tribal Mask' },
    { id: 'head15', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/871cec590_UntitledProject-2025-11-18T201539477.png', name: 'Beanie' },
    { id: 'head16', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/401a15704_UntitledProject-2025-11-18T200756786.png', name: 'MF DOOM Mask', width: 500, height: 500 },
]

const ACCESSORY_ASSETS = [
    { id: 'acc1', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/9974c3211_blunt-smoke-mlg-hitmarker-transparent-10.png', name: 'Blunt', width: 50, height: 50 },
    { id: 'acc2', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/02e8bcf9f_Chainasset.png', name: 'Chain' },
    { id: 'acc3', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/509220bd8_macheteasset.png', name: 'Machete' },
    { id: 'acc4', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/a4cea7f13_watchasset.png', name: 'Watch' },
    { id: 'acc5', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/235b47ee6_UntitledProject70.png', name: 'Spear' },
    { id: 'acc6', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/4da8af897_UntitledProject73.png', name: 'AK-47', width: 488, height: 488 },
    { id: 'acc7', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/673455a29_vapeasset.png', name: 'Vape' },
    { id: 'acc8', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/0a7994902_UntitledProject87.png', name: 'Energy Sword' },
    { id: 'acc9', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/e21ad93dc_UntitledProject89.png', name: 'Golden Scar' },
    { id: 'acc10', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/bc110bf14_UntitledProject94.png', name: 'Uganda Chain' },
    { id: 'acc11', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/74f5d9ac3_henneseybottle.png', name: 'Hennessy' },
    { id: 'acc12', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/38ad54458_doublecup.png', name: 'Double Cup' },
    { id: 'acc13', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/359e49029_handgun.png', name: 'Handgun' },
    { id: 'acc14', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/715c9c186_UntitledProject-2025-11-18T181144168.png', name: 'Uganda Shirt' },
    { id: 'acc15', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/d83abbf63_UntitledProject-2025-11-18T182841996.png', name: 'Quarter Zip', width: 505, height: 505 },
]

const BACKGROUND_ASSETS = [
    { id: 'bg1', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/fd222478f_backgroundasset1.jpg', name: 'Ebola Prevention' },
    { id: 'bg2', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/c70d62fe9_UntitledProject72.jpg', name: 'Corruption Billboard' },
    { id: 'bg3', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/d05873973_backgroundasset2.png', name: 'Beach Paradise' },
    { id: 'bg4', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/0bff80b99_UntitledProject72.png', name: 'Village' },
    { id: 'bg5', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/b263edefe_UntitledProject73.jpg', name: 'Uganda Map' },
    { id: 'bg6', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/8717ac5a6_UntitledProject74.jpg', name: 'Nightclub' },
    { id: 'bg7', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/e30d9bf53_UntitledProject75.jpg', name: 'Red Palm Oil' },
    { id: 'bg8', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/5204fbb25_UntitledProject80.jpg', name: 'UNICEF Camp' },
    { id: 'bg9', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/ba7647e8f_UntitledProject81.jpg', name: 'Traditional Village' },
]

const OVERLAY_ASSETS = [
    { id: 'overlay1', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/dadd65241_UntitledProject80.png', name: 'Mosquito', width: 500, height: 500, opacity: 0.5 },
    { id: 'overlay2', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/27d54f399_vroverlay.png', name: 'VR Chat', width: 500, height: 500 },
    { id: 'overlay3', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/f68dd6894_UntitledProject86.png', name: 'Uganda Flag', width: 500, height: 500, opacity: 0.7 },
    { id: 'overlay4', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/a894fbd1c_UntitledProject95.png', name: 'Malaria', width: 500, height: 500, opacity: 0.6 },
]

const AURA_ASSETS = [
    { id: 'aura1', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/e4f5fb51e_UntitledProject97.png', name: 'Golden Aura', width: 700, height: 700 },
    { id: 'aura2', url: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6918ea9b99b52aea48380167/0320aca58_UntitledProject98.png', name: 'Blue Aura', width: 500, height: 500 },
]

const clamp = (value, min, max) => Math.min(max, Math.max(min, value))
const createId = () => `el-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`

const getFittedDimensions = (width = 220, height = 220, maxDimension = 220) => {
    const safeWidth = Math.max(MIN_SIZE, width)
    const safeHeight = Math.max(MIN_SIZE, height)
    const scale = Math.min(1, maxDimension / Math.max(safeWidth, safeHeight))
    return {
        width: clamp(Math.round(safeWidth * scale), MIN_SIZE, MAX_SIZE),
        height: clamp(Math.round(safeHeight * scale), MIN_SIZE, MAX_SIZE),
    }
}

const getAxisBounds = (size) => ({
    min: Math.min(0, CANVAS_SIZE - size),
    max: Math.max(0, CANVAS_SIZE - size),
})

const clampElementToCanvas = (element) => {
    const width = clamp(element.width, MIN_SIZE, MAX_SIZE)
    const height = clamp(element.height, MIN_SIZE, MAX_SIZE)
    const xBounds = getAxisBounds(width)
    const yBounds = getAxisBounds(height)
    const x = clamp(element.x, xBounds.min, xBounds.max)
    const y = clamp(element.y, yBounds.min, yBounds.max)
    return { ...element, width, height, x, y }
}

const resizeElementWithinCanvas = (element, requestedWidth, requestedHeight) => {
    const width = clamp(requestedWidth, MIN_SIZE, MAX_SIZE)
    const height = clamp(requestedHeight, MIN_SIZE, MAX_SIZE)

    // When growing near canvas edges, shift position so resize can continue.
    const xBounds = getAxisBounds(width)
    const yBounds = getAxisBounds(height)
    const x = clamp(Math.min(element.x, xBounds.max), xBounds.min, xBounds.max)
    const y = clamp(Math.min(element.y, yBounds.max), yBounds.min, yBounds.max)

    return { ...element, width, height, x, y }
}

const getShirtLogoRect = (element) => ({
    x: element.width * SHIRT_LOGO_LEFT_RATIO,
    y: element.height * SHIRT_LOGO_TOP_RATIO,
    width: element.width * SHIRT_LOGO_WIDTH_RATIO,
    height: element.height * SHIRT_LOGO_HEIGHT_RATIO,
})

const normalizeAngle = (angle) => {
    let normalized = angle
    while (normalized > 180) normalized -= 360
    while (normalized < -180) normalized += 360
    return normalized
}

const loadImage = (sourceUrl) =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.crossOrigin = 'anonymous'
        image.onload = () => resolve(image)
        image.onerror = reject
        image.src = sourceUrl
    })

const trimTransparentImage = async (sourceUrl) => {
    const image = await loadImage(sourceUrl)
    const width = image.naturalWidth || image.width
    const height = image.naturalHeight || image.height
    if (!width || !height) {
        return { url: sourceUrl, width: 220, height: 220 }
    }

    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const context = canvas.getContext('2d')
    if (!context) {
        return { url: sourceUrl, width, height }
    }

    context.drawImage(image, 0, 0, width, height)

    let data
    try {
        data = context.getImageData(0, 0, width, height).data
    } catch {
        // CORS-protected assets cannot be read; fallback to original bounds safely.
        return { url: sourceUrl, width, height }
    }

    let minX = width
    let minY = height
    let maxX = -1
    let maxY = -1

    for (let y = 0; y < height; y += 1) {
        for (let x = 0; x < width; x += 1) {
            const alpha = data[(y * width + x) * 4 + 3]
            if (alpha > ALPHA_THRESHOLD) {
                minX = Math.min(minX, x)
                minY = Math.min(minY, y)
                maxX = Math.max(maxX, x)
                maxY = Math.max(maxY, y)
            }
        }
    }

    if (maxX < minX || maxY < minY) {
        return { url: sourceUrl, width, height }
    }

    const trimmedWidth = maxX - minX + 1
    const trimmedHeight = maxY - minY + 1
    const trimmedCanvas = document.createElement('canvas')
    trimmedCanvas.width = trimmedWidth
    trimmedCanvas.height = trimmedHeight
    const trimmedContext = trimmedCanvas.getContext('2d')
    if (!trimmedContext) {
        return { url: sourceUrl, width: trimmedWidth, height: trimmedHeight }
    }

    trimmedContext.drawImage(canvas, minX, minY, trimmedWidth, trimmedHeight, 0, 0, trimmedWidth, trimmedHeight)
    return {
        url: trimmedCanvas.toDataURL('image/png'),
        width: trimmedWidth,
        height: trimmedHeight,
    }
}

export default function PfpStudio() {
    const [elements, setElements] = useState([])
    const [selectedElementId, setSelectedElementId] = useState(null)
    const [zoom, setZoom] = useState(1)
    const [activeTab, setActiveTab] = useState('base')
    const [baseCharacter, setBaseCharacter] = useState(BASE_OPTIONS[0].url)
    const [textInput, setTextInput] = useState('')
    const [shirtColor, setShirtColor] = useState('#FCD34D')
    const [shirtLogoId, setShirtLogoId] = useState('none')
    const [shirtLayerSize, setShirtLayerSize] = useState(CANVAS_SIZE)
    const [logoLayerSize, setLogoLayerSize] = useState(170)
    const [uploadedAssets, setUploadedAssets] = useState([])
    const [customBackgrounds, setCustomBackgrounds] = useState([])
    const [dragState, setDragState] = useState(null)
    const [resizeState, setResizeState] = useState(null)
    const [rotateState, setRotateState] = useState(null)
    const canvasRef = useRef(null)
    const trimmedAssetCacheRef = useRef(new Map())

    const selectedElement = useMemo(
        () => elements.find((element) => element.id === selectedElementId) ?? null,
        [elements, selectedElementId]
    )

    const renderAssetGrid = (assets, onPick) => (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {assets.map((asset) => (
                <button
                    key={asset.id}
                    type="button"
                    onClick={() => onPick(asset)}
                    className="rounded border border-ugandan-red/40 hover:border-ugandan-red transition p-1 bg-black/20"
                >
                    <img src={asset.url} alt={asset.name} className="w-full aspect-square object-contain bg-white/5 rounded" />
                    <p className="text-[10px] mt-1">{asset.name}</p>
                </button>
            ))}
        </div>
    )

    const getTrimmedAsset = async (asset) => {
        const cacheKey = asset.url
        if (trimmedAssetCacheRef.current.has(cacheKey)) {
            return trimmedAssetCacheRef.current.get(cacheKey)
        }
        try {
            const trimmed = await trimTransparentImage(asset.url)
            trimmedAssetCacheRef.current.set(cacheKey, trimmed)
            return trimmed
        } catch {
            const fallback = { url: asset.url, width: asset.width ?? 220, height: asset.height ?? 220 }
            trimmedAssetCacheRef.current.set(cacheKey, fallback)
            return fallback
        }
    }

    const addLogoAsSeparateLayer = async () => {
        const selectedLogo = SHIRT_LOGOS.find((logo) => logo.id === shirtLogoId)
        if (!selectedLogo?.url) return

        const trimmed = await getTrimmedAsset({
            id: selectedLogo.id,
            name: selectedLogo.name,
            url: selectedLogo.url,
            width: logoLayerSize,
            height: logoLayerSize,
        })

        const fitted = getFittedDimensions(trimmed.width ?? logoLayerSize, trimmed.height ?? logoLayerSize, logoLayerSize)
        const targetShirt =
            (selectedElement?.type === 'shirt' ? selectedElement : null) ??
            [...elements].reverse().find((element) => element.type === 'shirt')

        const x = targetShirt
            ? targetShirt.x + targetShirt.width * SHIRT_LOGO_LEFT_RATIO + (targetShirt.width * SHIRT_LOGO_WIDTH_RATIO - fitted.width) / 2
            : (CANVAS_SIZE - fitted.width) / 2
        const y = targetShirt
            ? targetShirt.y + targetShirt.height * SHIRT_LOGO_TOP_RATIO + (targetShirt.height * SHIRT_LOGO_HEIGHT_RATIO - fitted.height) / 2
            : (CANVAS_SIZE - fitted.height) / 2

        addElement({
            type: 'image',
            name: `${selectedLogo.name} Logo`,
            content: trimmed.url,
            width: fitted.width,
            height: fitted.height,
            x,
            y,
        })
    }

    // Keep only valid object URLs from this session and release memory on unmount.
    useEffect(() => {
        return () => {
            uploadedAssets.forEach((asset) => URL.revokeObjectURL(asset.url))
            customBackgrounds.forEach((asset) => URL.revokeObjectURL(asset.url))
        }
    }, [uploadedAssets, customBackgrounds])

    useEffect(() => {
        if (!dragState) return
        const onPointerMove = (event) => {
            event.preventDefault()
            // Convert viewport movement to canvas movement so drag stays correct at any zoom.
            const deltaX = (event.clientX - dragState.startClientX) / zoom
            const deltaY = (event.clientY - dragState.startClientY) / zoom
            setElements((prev) =>
                prev.map((element) => {
                    if (element.id !== dragState.elementId) return element
                    return clampElementToCanvas({
                        ...element,
                        x: dragState.startX + deltaX,
                        y: dragState.startY + deltaY,
                    })
                })
            )
        }

        const onPointerUp = () => setDragState(null)

        window.addEventListener('pointermove', onPointerMove)
        window.addEventListener('pointerup', onPointerUp)
        return () => {
            window.removeEventListener('pointermove', onPointerMove)
            window.removeEventListener('pointerup', onPointerUp)
        }
    }, [dragState, zoom])

    useEffect(() => {
        if (!resizeState) return
        const onPointerMove = (event) => {
            event.preventDefault()
            const deltaX = (event.clientX - resizeState.startClientX) / zoom
            const deltaY = (event.clientY - resizeState.startClientY) / zoom
            setElements((prev) =>
                prev.map((element) => {
                    if (element.id !== resizeState.elementId) return element
                    return resizeElementWithinCanvas(
                        element,
                        resizeState.startWidth + deltaX,
                        resizeState.startHeight + deltaY
                    )
                })
            )
        }

        const onPointerUp = () => setResizeState(null)

        window.addEventListener('pointermove', onPointerMove)
        window.addEventListener('pointerup', onPointerUp)
        return () => {
            window.removeEventListener('pointermove', onPointerMove)
            window.removeEventListener('pointerup', onPointerUp)
        }
    }, [resizeState, zoom])

    useEffect(() => {
        if (!rotateState) return
        const onPointerMove = (event) => {
            event.preventDefault()
            const canvas = canvasRef.current
            if (!canvas) return
            const rect = canvas.getBoundingClientRect()
            const pointerX = (event.clientX - rect.left) / zoom
            const pointerY = (event.clientY - rect.top) / zoom
            const currentPointerAngle = Math.atan2(pointerY - rotateState.centerY, pointerX - rotateState.centerX) * (180 / Math.PI)
            const delta = normalizeAngle(currentPointerAngle - rotateState.startPointerAngle)
            setElements((prev) =>
                prev.map((element) =>
                    element.id === rotateState.elementId
                        ? { ...element, rotation: normalizeAngle(rotateState.startRotation + delta) }
                        : element
                )
            )
        }

        const onPointerUp = () => setRotateState(null)

        window.addEventListener('pointermove', onPointerMove)
        window.addEventListener('pointerup', onPointerUp)
        return () => {
            window.removeEventListener('pointermove', onPointerMove)
            window.removeEventListener('pointerup', onPointerUp)
        }
    }, [rotateState, zoom])

    const addElement = (payload) => {
        const layerCount = elements.filter((element) => typeof element.layer === 'number').length
        const width = clamp(payload.width ?? 180, MIN_SIZE, MAX_SIZE)
        const height = clamp(payload.height ?? 180, MIN_SIZE, MAX_SIZE)
        const x = payload.x ?? (CANVAS_SIZE - width) / 2
        const y = payload.y ?? (CANVAS_SIZE - height) / 2

        const nextElement = clampElementToCanvas({
            id: createId(),
            type: payload.type,
            content: payload.content,
            color: payload.color ?? '#FFFFFF',
            logo: payload.logo ?? null,
            x,
            y,
            width,
            height,
            rotation: payload.rotation ?? 0,
            opacity: clamp(payload.opacity ?? 1, MIN_OPACITY, MAX_OPACITY),
            layer: payload.layer ?? layerCount + 1,
            name: payload.name ?? payload.type,
        })

        setElements((prev) => [...prev, nextElement])
        setSelectedElementId(nextElement.id)
    }

    const addBackground = (url, name) => {
        setElements((prev) => {
            const withoutBackground = prev.filter((element) => element.layer !== BACKGROUND_LAYER)
            return [
                ...withoutBackground,
                {
                    id: createId(),
                    type: 'image',
                    name,
                    content: url,
                    x: 0,
                    y: 0,
                    width: CANVAS_SIZE,
                    height: CANVAS_SIZE,
                    rotation: 0,
                    opacity: 1,
                    layer: BACKGROUND_LAYER,
                    color: '#FFFFFF',
                    logo: null,
                },
            ]
        })
    }

    const addAura = async (asset) => {
        const trimmed = await getTrimmedAsset(asset)
        const fitted = getFittedDimensions(
            trimmed.width ?? asset.width ?? CANVAS_SIZE,
            trimmed.height ?? asset.height ?? CANVAS_SIZE,
            460
        )
        addElement({
            type: 'image',
            name: asset.name,
            content: trimmed.url,
            width: fitted.width,
            height: fitted.height,
            x: (CANVAS_SIZE - fitted.width) / 2,
            y: (CANVAS_SIZE - fitted.height) / 2,
            layer: AURA_LAYER,
            opacity: asset.opacity ?? 1,
        })
    }

    const updateSelected = (changes) => {
        if (!selectedElementId) return
        setElements((prev) =>
            prev.map((element) => {
                if (element.id !== selectedElementId) return element
                return clampElementToCanvas({ ...element, ...changes })
            })
        )
    }

    const deleteSelected = () => {
        if (!selectedElementId) return
        setElements((prev) => prev.filter((element) => element.id !== selectedElementId))
        setSelectedElementId(null)
    }

    const moveLayer = (direction) => {
        if (!selectedElement || typeof selectedElement.layer !== 'number') return
        const numericLayers = [...elements]
            .filter((element) => typeof element.layer === 'number')
            .sort((left, right) => left.layer - right.layer)
        const index = numericLayers.findIndex((element) => element.id === selectedElement.id)
        if (index === -1) return
        if (direction === 'up' && index === numericLayers.length - 1) return
        if (direction === 'down' && index === 0) return
        const swapIndex = direction === 'up' ? index + 1 : index - 1
        const current = numericLayers[index]
        const target = numericLayers[swapIndex]

        setElements((prev) =>
            prev.map((element) => {
                if (element.id === current.id) return { ...element, layer: target.layer }
                if (element.id === target.id) return { ...element, layer: current.layer }
                return element
            })
        )
    }

    const handleUpload = (event) => {
        const file = event.target.files?.[0]
        if (!file) return
        if (!file.type.startsWith('image/')) {
            window.alert('Please upload an image file.')
            return
        }
        const objectUrl = URL.createObjectURL(file)
        const newAsset = {
            id: createId(),
            name: file.name,
            url: objectUrl,
            width: 220,
            height: 220,
        }
        setUploadedAssets((prev) => [newAsset, ...prev])
        setActiveTab('uploads')
        event.target.value = ''
    }

    const handleBackgroundUpload = (event) => {
        const file = event.target.files?.[0]
        if (!file) return
        if (!file.type.startsWith('image/')) {
            window.alert('Please upload an image file.')
            return
        }

        const objectUrl = URL.createObjectURL(file)
        const newBackground = {
            id: createId(),
            name: file.name,
            url: objectUrl,
        }

        setCustomBackgrounds((prev) => [newBackground, ...prev])
        addBackground(objectUrl, file.name)
        event.target.value = ''
    }

    const drawImage = (context, src, transform, mode = 'stretch') =>
        new Promise((resolve) => {
            if (!src) {
                resolve()
                return
            }
            const image = new Image()
            image.crossOrigin = 'anonymous'
            image.onload = () => {
                context.save()
                context.globalAlpha = transform.opacity ?? 1
                context.translate(transform.x + transform.width / 2, transform.y + transform.height / 2)
                context.rotate((transform.rotation * Math.PI) / 180)

                if (mode === 'cover') {
                    const scale = Math.max(transform.width / image.width, transform.height / image.height)
                    const drawWidth = image.width * scale
                    const drawHeight = image.height * scale
                    context.drawImage(image, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight)
                } else if (mode === 'contain') {
                    const scale = Math.min(transform.width / image.width, transform.height / image.height)
                    const drawWidth = image.width * scale
                    const drawHeight = image.height * scale
                    context.drawImage(image, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight)
                } else {
                    context.drawImage(image, -transform.width / 2, -transform.height / 2, transform.width, transform.height)
                }
                context.restore()
                resolve()
            }
            image.onerror = () => resolve()
            image.src = src
        })

    const exportPng = async () => {
        const canvas = document.createElement('canvas')
        canvas.width = CANVAS_SIZE
        canvas.height = CANVAS_SIZE
        const context = canvas.getContext('2d')
        if (!context) {
            window.alert('Unable to create export canvas.')
            return
        }
        context.imageSmoothingEnabled = false

        const background = elements.find((element) => element.layer === BACKGROUND_LAYER)
        if (background) {
            await drawImage(context, background.content, background, 'cover')
        } else {
            context.fillStyle = '#111111'
            context.fillRect(0, 0, CANVAS_SIZE, CANVAS_SIZE)
        }

        const auraElements = elements.filter((element) => element.layer === AURA_LAYER)
        for (const aura of auraElements) {
            await drawImage(context, aura.content, aura)
        }

        // Use "contain" for base so different source dimensions remain centered and consistent.
        await drawImage(context, baseCharacter, { x: 0, y: 0, width: CANVAS_SIZE, height: CANVAS_SIZE, rotation: 0, opacity: 1 }, 'contain')

        const regularElements = [...elements]
            .filter((element) => typeof element.layer === 'number')
            .sort((left, right) => left.layer - right.layer)

        for (const element of regularElements) {
            if (element.type === 'text') {
                context.save()
                context.globalAlpha = element.opacity
                context.translate(element.x + element.width / 2, element.y + element.height / 2)
                context.rotate((element.rotation * Math.PI) / 180)
                context.font = `900 ${Math.max(20, element.width / 5)}px "Press Start 2P", monospace`
                context.textAlign = 'center'
                context.textBaseline = 'middle'
                context.fillStyle = element.color ?? '#FFFFFF'
                context.fillText((element.content ?? '').toUpperCase(), 0, 0)
                context.restore()
                continue
            }

            if (element.type === 'shirt') {
                try {
                    const shirtMask = await loadImage(element.content)
                    const temp = document.createElement('canvas')
                    temp.width = element.width
                    temp.height = element.height
                    const tempCtx = temp.getContext('2d')
                    if (!tempCtx) {
                        continue
                    }

                    tempCtx.fillStyle = element.color ?? '#FCD34D'
                    tempCtx.fillRect(0, 0, element.width, element.height)
                    tempCtx.globalCompositeOperation = 'destination-in'
                    tempCtx.drawImage(shirtMask, 0, 0, element.width, element.height)

                    if (element.logo) {
                        try {
                            const logoImage = await loadImage(element.logo)
                            const logoRect = getShirtLogoRect(element)
                            // Only draw the logo where shirt pixels already exist.
                            tempCtx.save()
                            tempCtx.globalCompositeOperation = 'source-atop'
                            tempCtx.drawImage(logoImage, logoRect.x, logoRect.y, logoRect.width, logoRect.height)
                            tempCtx.restore()
                        } catch {
                            // Skip logo if it fails to load; keep shirt render robust.
                        }
                    }

                    context.save()
                    context.globalAlpha = element.opacity
                    context.translate(element.x + element.width / 2, element.y + element.height / 2)
                    context.rotate((element.rotation * Math.PI) / 180)
                    context.drawImage(temp, -element.width / 2, -element.height / 2)
                    context.restore()
                } catch {
                    // Skip broken shirt asset in export instead of failing the full export.
                }
                continue
            }

            await drawImage(context, element.content, element, 'contain')
        }

        const dataUrl = canvas.toDataURL('image/png')
        const link = document.createElement('a')
        link.download = `dawae-pfp-${Date.now()}.png`
        link.href = dataUrl
        link.click()
    }

    const auraElements = elements.filter((element) => element.layer === AURA_LAYER)
    const regularElements = [...elements]
        .filter((element) => typeof element.layer === 'number')
        .sort((left, right) => left.layer - right.layer)
    const layersForPanel = [...regularElements].reverse()

    const startDraggingElement = (event, element) => {
        if (event.button !== 0 || resizeState || rotateState) return
        event.stopPropagation()
        event.preventDefault()
        setSelectedElementId(element.id)
        setDragState({
            elementId: element.id,
            startClientX: event.clientX,
            startClientY: event.clientY,
            startX: element.x,
            startY: element.y,
        })
    }

    const startResizingElement = (event, element) => {
        if (event.button !== 0 || dragState || rotateState) return
        event.stopPropagation()
        event.preventDefault()
        setSelectedElementId(element.id)
        setResizeState({
            elementId: element.id,
            startClientX: event.clientX,
            startClientY: event.clientY,
            startWidth: element.width,
            startHeight: element.height,
        })
    }

    const startRotatingElement = (event, element) => {
        if (event.button !== 0 || dragState || resizeState) return
        event.stopPropagation()
        event.preventDefault()
        const canvas = canvasRef.current
        if (!canvas) return
        const rect = canvas.getBoundingClientRect()
        const pointerX = (event.clientX - rect.left) / zoom
        const pointerY = (event.clientY - rect.top) / zoom
        const centerX = element.x + element.width / 2
        const centerY = element.y + element.height / 2
        const startPointerAngle = Math.atan2(pointerY - centerY, pointerX - centerX) * (180 / Math.PI)

        setSelectedElementId(element.id)
        setRotateState({
            elementId: element.id,
            centerX,
            centerY,
            startPointerAngle,
            startRotation: element.rotation ?? 0,
        })
    }

    return (
        <section className="py-10 text-ugandan-white">
            <div className="container mx-auto px-4">
                <div className="mb-6">
                    <h1 className="text-2xl md:text-3xl font-bold text-ugandan-red">PFP Studio</h1>
                    <p className="text-sm text-gray-300 mt-2">Create your Ugandan Knuckles PFP.</p>
                </div>

                <div className="grid lg:grid-cols-[320px_1fr_320px] gap-4">
                    <aside className="border border-ugandan-red/30 rounded-lg p-3 bg-black/30 space-y-3 h-fit">
                        <div className="flex flex-wrap gap-1 text-xs">
                            {['base', 'head', 'shirt', 'gear', 'aura', 'fx', 'bg', 'uploads', 'text'].map((tab) => (
                                <button
                                    key={tab}
                                    type="button"
                                    onClick={() => setActiveTab(tab)}
                                    className={`px-2 py-1 rounded border ${activeTab === tab ? 'border-ugandan-red bg-ugandan-red/20' : 'border-white/20'}`}
                                >
                                    {tab.toUpperCase()}
                                </button>
                            ))}
                        </div>

                        {activeTab === 'base' && (
                            renderAssetGrid(BASE_OPTIONS, (asset) => {
                                setBaseCharacter(asset.url)
                            })
                        )}
                        {activeTab === 'head' && (
                            renderAssetGrid(
                                HEAD_ASSETS,
                                async (asset) => {
                                    const trimmed = await getTrimmedAsset(asset)
                                    const fitted = getFittedDimensions(trimmed.width ?? asset.width ?? 260, trimmed.height ?? asset.height ?? 260, 210)
                                    addElement({ type: 'image', content: trimmed.url, name: asset.name, width: fitted.width, height: fitted.height })
                                }
                            )
                        )}
                        {activeTab === 'gear' && (
                            renderAssetGrid(
                                ACCESSORY_ASSETS,
                                async (asset) => {
                                    const trimmed = await getTrimmedAsset(asset)
                                    const fitted = getFittedDimensions(trimmed.width ?? asset.width ?? 240, trimmed.height ?? asset.height ?? 240, 190)
                                    addElement({ type: 'image', content: trimmed.url, name: asset.name, width: fitted.width, height: fitted.height })
                                }
                            )
                        )}
                        {activeTab === 'aura' && renderAssetGrid(AURA_ASSETS, addAura)}
                        {activeTab === 'fx' && (
                            renderAssetGrid(
                                OVERLAY_ASSETS,
                                (asset) =>
                                    addElement({
                                        type: 'image',
                                        content: asset.url,
                                        name: asset.name,
                                        width: asset.width ?? CANVAS_SIZE,
                                        height: asset.height ?? CANVAS_SIZE,
                                        opacity: asset.opacity ?? 1,
                                    })
                            )
                        )}
                        {activeTab === 'bg' && (
                            <div className="space-y-2">
                                <label className="block text-xs">Upload custom background</label>
                                <input type="file" accept="image/*" onChange={handleBackgroundUpload} className="block w-full text-xs" />
                                {customBackgrounds.length > 0 && (
                                    <div className="space-y-1">
                                        <p className="text-[10px] text-gray-300 uppercase">Custom Backgrounds</p>
                                        {renderAssetGrid(customBackgrounds, (asset) => addBackground(asset.url, asset.name))}
                                    </div>
                                )}
                                <div className="space-y-1">
                                    <p className="text-[10px] text-gray-300 uppercase">Default Backgrounds</p>
                                    {renderAssetGrid(BACKGROUND_ASSETS, (asset) => addBackground(asset.url, asset.name))}
                                </div>
                            </div>
                        )}
                        {activeTab === 'uploads' && (
                            <div className="space-y-2">
                                <label className="block text-xs">Upload image</label>
                                <input type="file" accept="image/*" onChange={handleUpload} className="block w-full text-xs" />
                                {renderAssetGrid(uploadedAssets, async (asset) => {
                                    const trimmed = await getTrimmedAsset(asset)
                                    const fitted = getFittedDimensions(trimmed.width ?? asset.width ?? 240, trimmed.height ?? asset.height ?? 240, 200)
                                    addElement({ type: 'image', content: trimmed.url, name: asset.name, width: fitted.width, height: fitted.height })
                                })}
                            </div>
                        )}
                        {activeTab === 'shirt' && (
                            <div className="space-y-3">
                                <label className="text-xs block">Shirt color</label>
                                <input type="color" value={shirtColor} onChange={(event) => setShirtColor(event.target.value)} className="w-full h-10" />

                                <label className="text-xs block">Shirt size: {Math.round(shirtLayerSize)}px</label>
                                <input
                                    type="range"
                                    min={220}
                                    max={CANVAS_SIZE}
                                    value={shirtLayerSize}
                                    onChange={(event) => setShirtLayerSize(Number(event.target.value))}
                                    className="w-full"
                                />

                                <select value={shirtLogoId} onChange={(event) => setShirtLogoId(event.target.value)} className="w-full bg-black border border-white/30 rounded px-2 py-2 text-xs">
                                    {SHIRT_LOGOS.map((logo) => (
                                        <option key={logo.id} value={logo.id}>
                                            {logo.name}
                                        </option>
                                    ))}
                                </select>

                                <label className="text-xs block">Separate logo size: {Math.round(logoLayerSize)}px</label>
                                <input
                                    type="range"
                                    min={50}
                                    max={320}
                                    value={logoLayerSize}
                                    onChange={(event) => setLogoLayerSize(Number(event.target.value))}
                                    className="w-full"
                                />

                                <button
                                    type="button"
                                    onClick={() =>
                                        addElement({
                                            type: 'shirt',
                                            name: 'Custom Shirt',
                                            content: SHIRT_MASK_URL,
                                            logo: SHIRT_LOGOS.find((logo) => logo.id === shirtLogoId)?.url ?? null,
                                            color: shirtColor,
                                            width: shirtLayerSize,
                                            height: shirtLayerSize,
                                        })
                                    }
                                    className="w-full bg-ugandan-red hover:bg-ugandan-red/80 py-2 rounded text-xs"
                                >
                                    Add Shirt
                                </button>

                                <button
                                    type="button"
                                    onClick={addLogoAsSeparateLayer}
                                    disabled={shirtLogoId === 'none'}
                                    className="w-full border border-ugandan-red/70 text-ugandan-white hover:bg-ugandan-red/20 py-2 rounded text-xs disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Add Logo Layer (Separate)
                                </button>
                            </div>
                        )}
                        {activeTab === 'text' && (
                            <div className="space-y-2">
                                <input
                                    value={textInput}
                                    onChange={(event) => setTextInput(event.target.value)}
                                    maxLength={30}
                                    placeholder="Type text..."
                                    className="w-full bg-black border border-white/30 rounded px-2 py-2 text-xs"
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (!textInput.trim()) return
                                        addElement({ type: 'text', name: 'Text', content: textInput, width: 220, height: 90, color: '#FFFFFF' })
                                        setTextInput('')
                                    }}
                                    className="w-full bg-ugandan-red hover:bg-ugandan-red/80 py-2 rounded text-xs"
                                >
                                    Add Text
                                </button>
                            </div>
                        )}
                    </aside>

                    <main className="space-y-3">
                        <div className="flex flex-wrap gap-2 items-center justify-between">
                            <div className="flex gap-2">
                                <button type="button" onClick={() => setZoom((prev) => clamp(prev - 0.1, MIN_ZOOM, MAX_ZOOM))} className="px-3 py-1 text-xs border border-white/30 rounded">-</button>
                                <span className="text-xs px-2 py-1 border border-white/20 rounded">{Math.round(zoom * 100)}%</span>
                                <button type="button" onClick={() => setZoom((prev) => clamp(prev + 0.1, MIN_ZOOM, MAX_ZOOM))} className="px-3 py-1 text-xs border border-white/30 rounded">+</button>
                            </div>
                            <button type="button" onClick={exportPng} className="bg-ugandan-red hover:bg-ugandan-red/80 px-4 py-2 rounded text-xs font-semibold">
                                Export PNG
                            </button>
                        </div>

                        <div className="overflow-auto border border-ugandan-red/30 rounded-lg p-3 bg-black/30">
                            <div style={{ width: CANVAS_SIZE * zoom, height: CANVAS_SIZE * zoom }} className="mx-auto relative">
                                <div
                                    ref={canvasRef}
                                    className="absolute inset-0 origin-top-left border border-white/20 bg-black touch-none"
                                    style={{ width: CANVAS_SIZE, height: CANVAS_SIZE, transform: `scale(${zoom})`, transformOrigin: 'top left' }}
                                    onPointerDown={(event) => {
                                        if (event.target === canvasRef.current) setSelectedElementId(null)
                                    }}
                                >
                                    {elements
                                        .filter((element) => element.layer === BACKGROUND_LAYER)
                                        .map((element) => (
                                            <img key={element.id} src={element.content} alt={element.name} className="absolute inset-0 w-full h-full object-cover" />
                                        ))}
                                    {auraElements.map((element) => (
                                        <div
                                            key={element.id}
                                            className={`absolute object-contain cursor-move ${selectedElementId === element.id ? 'ring-2 ring-ugandan-red' : ''}`}
                                            style={{ left: element.x, top: element.y, width: element.width, height: element.height, opacity: element.opacity, transform: `rotate(${element.rotation}deg)` }}
                                            onPointerDown={(event) => startDraggingElement(event, element)}
                                        >
                                            <img src={element.content} alt={element.name} className="w-full h-full object-contain pointer-events-none" />
                                            {selectedElementId === element.id && (
                                                <>
                                                    <button
                                                        type="button"
                                                        className="absolute left-1/2 -translate-x-1/2 -top-6 w-4 h-4 rounded-full bg-ugandan-red border border-white cursor-grab"
                                                        onPointerDown={(event) => startRotatingElement(event, element)}
                                                        aria-label="Rotate selected aura with mouse"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="absolute -right-2 -bottom-2 w-4 h-4 rounded-sm bg-ugandan-red border border-white cursor-se-resize"
                                                        onPointerDown={(event) => startResizingElement(event, element)}
                                                        aria-label="Resize selected aura with mouse"
                                                    />
                                                </>
                                            )}
                                        </div>
                                    ))}

                                    <img src={baseCharacter} alt="Base character" className="absolute inset-0 w-full h-full object-contain pointer-events-none" />

                                    {regularElements.map((element) => (
                                        <div
                                            key={element.id}
                                            className={`absolute cursor-move ${selectedElementId === element.id ? 'ring-2 ring-ugandan-red' : ''}`}
                                            style={{ left: element.x, top: element.y, width: element.width, height: element.height, opacity: element.opacity, transform: `rotate(${element.rotation}deg)` }}
                                            onPointerDown={(event) => startDraggingElement(event, element)}
                                        >
                                            {element.type === 'text' ? (
                                                <div className="w-full h-full flex items-center justify-center text-center text-white font-arcade text-xs break-words px-1">
                                                    {(element.content ?? '').toUpperCase()}
                                                </div>
                                            ) : element.type === 'shirt' ? (
                                                <div className="w-full h-full relative">
                                                    <div
                                                        className="w-full h-full"
                                                        style={{
                                                            backgroundColor: element.color,
                                                            WebkitMaskImage: `url(${element.content})`,
                                                            WebkitMaskPosition: 'center',
                                                            WebkitMaskSize: 'contain',
                                                            WebkitMaskRepeat: 'no-repeat',
                                                            maskImage: `url(${element.content})`,
                                                            maskPosition: 'center',
                                                            maskSize: 'contain',
                                                            maskRepeat: 'no-repeat',
                                                        }}
                                                    />
                                                    {element.logo && (
                                                        <div
                                                            className="absolute inset-0 pointer-events-none"
                                                            style={{
                                                                WebkitMaskImage: `url(${element.content})`,
                                                                WebkitMaskPosition: 'center',
                                                                WebkitMaskSize: 'contain',
                                                                WebkitMaskRepeat: 'no-repeat',
                                                                maskImage: `url(${element.content})`,
                                                                maskPosition: 'center',
                                                                maskSize: 'contain',
                                                                maskRepeat: 'no-repeat',
                                                            }}
                                                        >
                                                            <img
                                                                src={element.logo}
                                                                alt="Shirt logo"
                                                                className="absolute object-contain"
                                                                style={{
                                                                    left: `${SHIRT_LOGO_LEFT_RATIO * 100}%`,
                                                                    top: `${SHIRT_LOGO_TOP_RATIO * 100}%`,
                                                                    width: `${SHIRT_LOGO_WIDTH_RATIO * 100}%`,
                                                                    height: `${SHIRT_LOGO_HEIGHT_RATIO * 100}%`,
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <img src={element.content} alt={element.name} className="w-full h-full object-contain" />
                                            )}
                                            {selectedElementId === element.id && (
                                                <>
                                                    <button
                                                        type="button"
                                                        className="absolute left-1/2 -translate-x-1/2 -top-6 w-4 h-4 rounded-full bg-ugandan-red border border-white cursor-grab"
                                                        onPointerDown={(event) => startRotatingElement(event, element)}
                                                        aria-label="Rotate selected element with mouse"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="absolute -right-2 -bottom-2 w-4 h-4 rounded-sm bg-ugandan-red border border-white cursor-se-resize"
                                                        onPointerDown={(event) => startResizingElement(event, element)}
                                                        aria-label="Resize selected element with mouse"
                                                    />
                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </main>

                    <aside className="border border-ugandan-red/30 rounded-lg p-3 bg-black/30 space-y-3 h-fit">
                        <h2 className="text-sm font-semibold text-ugandan-red">Element Controls</h2>
                        {!selectedElement && <p className="text-xs text-gray-300">Select an element to move, resize, rotate, reorder, or delete it.</p>}

                        {selectedElement && (
                            <div className="space-y-2 text-xs">
                                <p className="text-gray-200">
                                    <span className="text-gray-400">Selected:</span> {selectedElement.name}
                                </p>
                                <label className="block">Width: {Math.round(selectedElement.width)}px</label>
                                <input type="range" min={MIN_SIZE} max={MAX_SIZE} value={selectedElement.width} onChange={(event) => updateSelected({ width: clamp(Number(event.target.value), MIN_SIZE, MAX_SIZE) })} className="w-full" />
                                <label className="block">Height: {Math.round(selectedElement.height)}px</label>
                                <input type="range" min={MIN_SIZE} max={MAX_SIZE} value={selectedElement.height} onChange={(event) => updateSelected({ height: clamp(Number(event.target.value), MIN_SIZE, MAX_SIZE) })} className="w-full" />
                                <label className="block">Rotation: {Math.round(selectedElement.rotation)}deg</label>
                                <input type="range" min={-180} max={180} value={selectedElement.rotation} onChange={(event) => updateSelected({ rotation: Number(event.target.value) })} className="w-full" />
                                <label className="block">Opacity: {selectedElement.opacity.toFixed(2)}</label>
                                <input type="range" min={MIN_OPACITY} max={MAX_OPACITY} step="0.01" value={selectedElement.opacity} onChange={(event) => updateSelected({ opacity: clamp(Number(event.target.value), MIN_OPACITY, MAX_OPACITY) })} className="w-full" />

                                {selectedElement.type === 'shirt' && (
                                    <>
                                        <label className="block">Shirt color</label>
                                        <input type="color" value={selectedElement.color ?? '#FCD34D'} onChange={(event) => updateSelected({ color: event.target.value })} className="w-full h-9" />
                                    </>
                                )}

                                {typeof selectedElement.layer === 'number' && (
                                    <div className="flex gap-2">
                                        <button type="button" onClick={() => moveLayer('down')} className="flex-1 border border-white/20 rounded py-1">Layer -</button>
                                        <button type="button" onClick={() => moveLayer('up')} className="flex-1 border border-white/20 rounded py-1">Layer +</button>
                                    </div>
                                )}

                                <button type="button" onClick={deleteSelected} className="w-full bg-ugandan-red/80 hover:bg-ugandan-red py-2 rounded">
                                    Delete Selected
                                </button>
                            </div>
                        )}

                        {layersForPanel.length > 0 && (
                            <div className="space-y-1 pt-2 border-t border-white/10">
                                <h3 className="text-xs font-semibold text-ugandan-red">Layers</h3>
                                {layersForPanel.map((element) => (
                                    <button
                                        key={element.id}
                                        type="button"
                                        onClick={() => setSelectedElementId(element.id)}
                                        className={`w-full text-left px-2 py-1 rounded border ${selectedElementId === element.id ? 'border-ugandan-red bg-ugandan-red/20' : 'border-white/10'}`}
                                    >
                                        {element.name}
                                    </button>
                                ))}
                            </div>
                        )}
                    </aside>
                </div>
            </div>
        </section>
    )
}
